import { Route, Switch } from "react-router-dom";
import PagarPages from "./Pagar";
import ContaRecorrenteDespesaPage from "./ContaRecorrente/index";

function DespesaPages() {
  return (
    <Switch>
      <Route path="/financeiro/despesa/pagar" component={PagarPages} />
      <Route
        path="/financeiro/despesa/conta-recorrente"
        component={ContaRecorrenteDespesaPage}
      />
    </Switch>
  );
}

export default DespesaPages;
